import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Message", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.action.message = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.message]
      ])
    ])
  ]))
}